import { getTextWithLinks } from 'components/Conversations'
import ReactMarkdown from 'react-markdown'

const ReactMarkdownComponents = {
  p(props: any) {
    if (typeof props.children === 'string') {
      return (
        <p
          style={{
            margin: 0,
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: 0,
            fontSize: '14px',
            alignSelf: 'flex-start',
          }}>
          {getTextWithLinks(props.children)}
        </p>
      )
    }

    return (
      <p
        style={{
          margin: 0,
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: 0,
          fontSize: '14px',
          alignSelf: 'flex-start',
        }}>
        {props.children}
      </p>
    )
  },
  h3(props: any) {
    return (
      <h3
        style={{
          alignSelf: 'flex-start',
        }}>
        {props.children}
      </h3>
    )
  },
  ul(props: any) {
    return <ul style={{ marginLeft: '-24px', alignSelf: 'flex-start', whiteSpace: 'nowrap' }}>{props.children}</ul>
  },
  ol(props: any) {
    return <ol style={{ marginLeft: '-24px', whiteSpace: 'nowrap' }}>{props.children}</ol>
  },
  li(props: any) {
    return (
      <li
        style={{
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: 0,
          fontSize: '14px',
          marginBottom: '4px',
          alignSelf: 'flex-start',
        }}>
        {props.children}
      </li>
    )
  },
}

const TextWithMarkdown = ({ text }: { text: string }) => {
  return <ReactMarkdown components={ReactMarkdownComponents} children={text} />
}

export default TextWithMarkdown
